module.exports = __webpack_public_path__ + "assets/img/index-partner2.f111a088.jpg";